import { render, staticRenderFns } from "./Marcas_editar.vue?vue&type=template&id=3c0aa025"
import script from "./Marcas_editar.vue?vue&type=script&lang=js"
export * from "./Marcas_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports